import theme from '@/theme';
import { Typography } from '@montugroup/design-system';
import ErrorIcon from '@mui/icons-material/Error';
import { Box } from '@mui/material';

const FetchFailedError = () => {
  return (
    <Box textAlign="center">
      <ErrorIcon color="error" sx={{ fontSize: 20 }} />
      <Typography variant="body1" color={theme.palette.error.main}>
        Something went wrong
        <br />
        There was a problem fetching the data. Please try again.
      </Typography>
    </Box>
  );
};

export default FetchFailedError;
